<template>
  <v-container fluid class="analytics-pdr">
    <analytics-compare v-model="compares" @compare="handleCompare" />

    <div class="mt-5">
      <component
        :is="componentName"
        :title="title"
        :compares="compares"
        :data="data"
      />
    </div>
  </v-container>
</template>

<script>
import AnalyticsCompare from '@/components/analytics/AnalyticsCompare'
import DonutChart from './components/DonutChart'
import BarWithNegativeChart from './components/BarWithNegativeChart'

import { analyticsServices } from '@/services/db'

const CHART = {
  DONUT: 'DONUT',
  BAR_WITH_NAGATIVE: 'BAR_WITH_NAGATIVE',
}

export default {
  name: 'AnalyticsSixMin',
  components: {
    AnalyticsCompare,
  },
  data() {
    return {
      chartType: '',
      compares: [],
      data: [],
    }
  },
  computed: {
    isSingle() {
      return this.compares.length === 1
    },
    componentName() {
      switch (this.chartType) {
        case CHART.DONUT:
          return DonutChart
        case CHART.BAR_WITH_NAGATIVE:
          return BarWithNegativeChart
        default:
          return null
      }
    },
    title() {
      switch (this.chartType) {
        case CHART.DONUT:
          return '退出時間大於六分鐘比例'
        case CHART.BAR_WITH_NAGATIVE:
          return '退出時間大於六分鐘比較'
        default:
          return ''
      }
    },
  },
  methods: {
    genParam(item) {
      return {
        ...item.date,
        doctor: item.doctor,
      }
    },
    getParams() {
      return this.compares.map(this.genParam)
    },
    handleCompare() {
      this.chartType = this.isSingle ? CHART.DONUT : CHART.BAR_WITH_NAGATIVE
      analyticsServices
        .queryWithdrawTime(this.getParams())
        .then(data => (this.data = data))
    },
  },
}
</script>
